module.exports = __webpack_public_path__ + "static/media/vector.8e9cf5ef.svg";